export default "__VITE_ASSET__CSU4FIu3__"